<template>
   <div class="theme-selector text-center">
      <mq-layout :mq="['xs', 'sm', 'md']">
         <BaseDropdown
            v-model="selectedTheme"
            :options="themes"
            class="theme-selector-dropdown"
            placeholder="Choose a theme"
         />
      </mq-layout>
      <mq-layout mq="lg+">
         <div class="theme-large-container">
            <span v-if="!langType" class="theme-selector-label">Themes:</span>
            <span v-if="langType" class="theme-selector-label">主题:</span>
            <fieldset role="group" class="theme-selector-list b-form-group form-group">
               <div role="group" class="">
                  <div role="radiogroup" tabindex="-1" class="theme-selector-item">
                     <div
                        v-for="(item, index) in themes"
                        :key="index"
                        class="custom-control custom-radio custom-control-inline"
                     >
                        <input
                           :id="index"
                           v-model="selectedTheme"
                           type="radio"
                           class="custom-control-input"
                           :value="item.value"
                        /><label :for="index" class="custom-control-label">
                           <span v-text="item.text" />
                        </label>
                     </div>
                  </div>
               </div>
            </fieldset>
         </div>
      </mq-layout>
   </div>
</template>
<script>
import BaseDropdown from '../core/BaseDropdown';
import config from '../config';

export default {
   components: {
      BaseDropdown,
   },

   props: {
      tabIndex: {
         type: String,
         default: '',
      },
      containerId: {
         type: String,
         required: true,
      },

      langType: {
         type: Object,
         default: () => {},
      },
   },

   data: () => ({
      themes: config.themes,
      // Hardcoded rather than config.defaultTheme: the homepage showcase
      // (ChartShowcase.vue) always force-renders its chart with the candy
      // theme regardless of this shared config's default, so this selector
      // needs its own fixed starting value to stay in sync with what's
      // actually on screen - other pages using config.defaultTheme (which
      // now defaults to 'fusion') are unaffected by this override.
      selectedTheme: 'candy',
   }),

   watch: {
      tabIndex() {
         this.selectedTheme = 'candy';
      },

      selectedTheme() {
         const dom = document.getElementById(this.containerId);
         if (dom) {
            const chartId = dom.firstElementChild.getAttribute('id');
            const chartInstance = FusionCharts.items[chartId];
            chartInstance && chartInstance.setChartAttribute('theme', this.selectedTheme);
         }
      },
   },
};
</script>
